import {Container, Col, Row }from 'react-bootstrap';
import { Link, Instagram, Youtube} from 'react-bootstrap-icons';




function Footer(){
    return (
        <> 
            <Container fluid className="color-bg-secondary">
                <Row className="border-top">
                    <Col>
                        <div className="text-start">
                            <a href="/privacy" className="font-body color-font-primary font-size-small text-start url-style"><Link /> Privacy Policy</a>
                        </div>
                        <div className="text-start">
                            <a href="/terms" className="font-body color-font-primary font-size-small text-start url-style"><Link /> Terms and Conditions</a>
                        </div>
                    </Col>
                    <Col>
                        <div className="text-start">
                            <a href="/services" className="font-body color-font-primary font-size-small text-start url-style"><Link /> What we do</a>
                        </div>
                        <div className="text-start">
                            <a href="/audience" className="font-body color-font-primary font-size-small text-start url-style"><Link /> Who we serve</a>
                        </div>
                    </Col>
                    <Col md={{span: 3}}>
                        <Row className="py-2">
                            <Col className="d-flex align-items-center justify-content-center" onClick={()=> window.open("https://www.instagram.com/bigdistanceenergy/", "_blank")}>
                                <div className="url-func square-block py-2">
                                    <div>
                                        <Instagram size={26} className='color-font-primary'/>
                                    </div>
                                    <div>
                                        <p className="font-body color-font-primary font-size-small">Instagram</p>
                                    </div>
                                </div>
                            </Col>
                            <Col className="d-flex align-items-center justify-content-center" onClick={()=> window.open("https://www.youtube.com/@BigDistanceEnergy/videos", "_blank")}>
                                <div className="url-func square-block py-2">
                                    <div>
                                        <Youtube size={26} className='color-font-primary-youtube'/>
                                    </div>
                                    <div>
                                        <p className="font-body color-font-primary font-size-small">Youtube</p>
                                    </div>
                                </div>
                            </Col>
                            
                        </Row>
                    </Col>
                </Row>
                <Row className="color-bg-primary">
                    <Col>
                        <p className="font-body color-font-secondary font-size-tiny">Big Distance Energy Creative, LLC. &copy;  All Rights Reserved</p>
                    </Col>
                </Row>
            </Container>


        </>
    )
}

export default Footer;